import { AxiosResponse, AxiosInstance } from "axios";
export interface UpdateInstancePayload {
    description: string;
}

export function fetchLicensedInstances(
    axiosInstance: AxiosInstance,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/list?tenantId=${tenantId}`);
}

export function fetchLicensedInstanceById(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`);
}

export function updateLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number,
    payload: UpdateInstancePayload
): Promise<AxiosResponse> {
    return axiosInstance.put(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`, payload);
}

export function deleteLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    tenantId: number
): Promise<AxiosResponse> {
    return axiosInstance.delete(`/ctxr/-1/RemoveLicense/${instanceId}?tenantId=${tenantId}`);
}
